import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import { LinkTo } from '../../../PageLayout/Link/Link';
import TagListEditor from './TagListEditor';
import Markdown from './Markdown';
import ProjectUserPref from './ProjectUserPref';
import ProjectService from '../../../Services/ProjectService';
import Ellipsis from 'clamp-js';
import projectImagePlaceholder from "images/projectImagePlaceholder.svg";
import AuthorizeService from "../../../ApiAuthorization/AuthorizeService.js";

class ProjectCardDescription extends Component {
  static propTypes = {
    project: PropTypes.any.isRequired,
    availableTags: PropTypes.array.isRequired,
  }

  constructor(props) {
    super(props);
    const currentUser = AuthorizeService.getUser();
    this.state = {
      projectImage: projectImagePlaceholder,
      isOwnerOrContrib: props.project.project.projectUsers
        .findIndex(user => user.user.upn === currentUser.preferred_username) !== -1,
    };
  }

  async componentDidMount() {
    try {
      const imageUrl = await ProjectService.getProjectImage(this.props.project.project.projectId);
      this.setState({ projectImage: imageUrl });
    } catch (error) {
      clearTimeout(error.errorDisplayTimer)
    }
  }

  render() {
    const creator = this.props.project.project.projectUsers.find(e => e.profileTypeRefId === "ADMIN");
    let descriptionMarkdown = this.props.project.project.devOpsDescription;
    const isPrivate = this.props.project.project.private;
    if (descriptionMarkdown && descriptionMarkdown.length > 200) {
      descriptionMarkdown = descriptionMarkdown.substr(0, 200) + '...' ;
    }
    return (
      <Card className='projectCardDescription'>
        <Card.Img variant="top" src={this.state.projectImage} {...LinkTo(`/project/${this.props.project.project.projectId}`)} title={'Open project page'} />
        <Card.Body>
          <div className='cardTitle'>
            <h5 className='routerlink' {...LinkTo(`/project/${this.props.project.project.projectId}`)} title={'Open project page'} ref={(r) => { r && Ellipsis(r, { clamp: 2 }); }}>
              {this.props.project.project.name}
            </h5>
            {creator &&
              <span className="author">by {creator.user.firstName} {creator.user.lastName}</span>
            }
            <ProjectUserPref projectId={this.props.project.project.projectId}></ProjectUserPref>
          </div>
          <div>
            {
              !this.state.isOwnerOrContrib && isPrivate? <div className="confidentialImg">Confidential</div>: descriptionMarkdown && descriptionMarkdown.length > 0
                ? <Markdown projectId={this.props.project.project.projectId} maxSize={221} >{descriptionMarkdown}</Markdown>
                : this.props.project.project.description
            }

          </div>
          <TagListEditor
            defaultValue={this.props.project.project.projectTags}
            availableTags={this.props.availableTags}
            preview={true}
            disable={true}
            maxDisplayCount={3}
          />
        </Card.Body>
      </Card>
    );
  }
}

export default ProjectCardDescription;
